import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import "bootstrap/dist/css/bootstrap.min.css";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Title from "../Layout/Title";
import Media from "react-media";

import Avatar from "@material-ui/core/Avatar";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import InfoIcon from "@material-ui/icons/Info";
import FeedbackIcon from "@material-ui/icons/Feedback";
import PolicyIcon from "@material-ui/icons/Policy";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import MuiLink from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import TextField from "@material-ui/core/TextField";

//Redux stuff
import { logoutUser } from "../../redux/actions/userActions";

const Menu = ({ user, logoutUser }) => {
  console.log(user);
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dropdown>
      <Dropdown.Toggle id="dropdown-basic">
        {user.credentials.imageUrl !==
        "https://firebasestorage.googleapis.com/v0/b/studybud-6bcea.appspot.com/o/no-image.webp?alt=media" ? (
          <Avatar
            alt={user.credentials.username}
            src={user.credentials.imageUrl}
          />
        ) : (
          <Avatar
            alt={user.credentials.username.toUpperCase()}
            src="/static/images/avatar/1.jpg"
          />
        )}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item>
          <MuiLink
            component={Link}
            to={`/users/${user.credentials.username}`}
            color="inherit"
          >
            <AccountCircleIcon style={{ marginRight: "0.3rem" }} />
            Your Profile
          </MuiLink>
        </Dropdown.Item>
        <Dropdown.Item>
          <FeedbackIcon style={{ marginRight: "0.3rem" }} />
          <Button onClick={handleClickOpen}>Give Feedback</Button>
          <Media queries={{ small: "(max-width:768px)" }}>
            {(matches) =>
              matches.small ? (
                <Dialog
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="form-dialog-title"
                  fullScreen
                >
                  <DialogTitle id="form-dialog-title">
                    <Title label="Give feedback to Studybud" />
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      <Typography>
                        Note: This is a beta version for testing purposes.Please
                        give us feedback so that we can improve your Studybud
                        experience.
                      </Typography>
                    </DialogContentText>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="name"
                      label="Help us improve Studybud"
                      placeholder="Give feedback about your Studybud experience"
                      type="text"
                      fullWidth
                      variant="outlined"
                      multiline
                      rows={8}
                    />
                    <TextField
                      autoFocus
                      margin="dense"
                      id="name"
                      label="Something went wrong?"
                      placeholder="Let us know  about a broken feature"
                      type="text"
                      fullWidth
                      variant="outlined"
                      multiline
                      rows={8}
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleClose} style={{ color: "#e50f19" }}>
                      Cancel
                    </Button>
                    <Button onClick={handleClose} color="primary">
                      Submit
                    </Button>
                  </DialogActions>
                </Dialog>
              ) : (
                <Dialog
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="form-dialog-title"
                >
                  <DialogTitle id="form-dialog-title">
                    <Title label="Give feedback to Studybud" />
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      <Typography>
                        Note: This is a beta version for testing purposes.Please
                        give us feedback so that we can improve your Studybud
                        experience.
                      </Typography>
                    </DialogContentText>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="name"
                      label="Help us improve Studybud"
                      placeholder="Give feedback about your Studybud experience"
                      type="text"
                      fullWidth
                      variant="outlined"
                      multiline
                      rows={5}
                    />
                    <TextField
                      autoFocus
                      margin="dense"
                      id="name"
                      label="Something went wrong?"
                      placeholder="Let us know  about a broken feature"
                      type="text"
                      fullWidth
                      variant="outlined"
                      multiline
                      rows={5}
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleClose} style={{ color: "#e50f19" }}>
                      Cancel
                    </Button>
                    <Button onClick={handleClose} color="primary">
                      Submit
                    </Button>
                  </DialogActions>
                </Dialog>
              )
            }
          </Media>
        </Dropdown.Item>
        <Dropdown.Item>
          <MuiLink component={Link} to={`/support`} color="inherit">
            <MonetizationOnIcon style={{ marginRight: "0.3rem" }} />
            Support Us
          </MuiLink>
        </Dropdown.Item>
        <Dropdown.Item href="/action-1">
          <MuiLink component={Link} to={`/about`} color="inherit">
            <InfoIcon style={{ marginRight: "0.3rem" }} />
            About Us
          </MuiLink>
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item onClick={() => logoutUser()}>
          <ExitToAppIcon style={{ marginRight: "0.3rem" }} />
          Logout
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

const mapActionsToProps = { logoutUser };

Menu.propTypes = {
  logoutUser: PropTypes.func.isRequired,
};

export default connect(null, mapActionsToProps)(Menu);
